import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, ScrollView, Dimensions, KeyboardAvoidingView, Platform } from "react-native"


import tw from '../../styles/tailwind';
import Text from '../../components/Text';
import api from '../../utils/api';
import SignUpForm from './SignupForm';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';
import { Image } from 'expo-image';
import { Illustration } from '../../components/Illustration';
import DDCircle from '../../assets/images/svgs/dd_circle'

import Animated, { useSharedValue, withSpring } from 'react-native-reanimated';
import WelcomeWizard from './WelcomeWizard';
import StoreBadges from './StoreBadges';
import { actions } from '@/store/Reducers/auth';
import { updateStatus } from '@/store/Reducers/status';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';


function WelcomeScreen({invitation}){
  const dimensions = Dimensions.get('screen')
  // console.log(dimensions);
  const top = useSharedValue(0);

  // web: true cuando el intento de abrir la app no logra sacar al usuario del
  // navegador (heurístico) => asumimos que la app no está instalada.
  const [appMissing, setAppMissing] = useState(false);

  const hide = () => {
    top.value = withSpring(top.value - dimensions.height);
  };

  // Intenta abrir la app nativa vía custom scheme (no el https del mismo dominio,
  // que iOS/Android ignoran por venir de app.ding-dong.mx). Si a los ~1.8s la
  // pestaña sigue visible, damos por hecho que no está instalada.
  const tryOpenApp = () => {
    const schemeUrl = `dingdong://i/${invitation.uuid}`;
    let switchedAway = false;

    const onAway = () => { switchedAway = true; };
    document.addEventListener('visibilitychange', onAway);
    window.addEventListener('pagehide', onAway);
    window.addEventListener('blur', onAway);

    setAppMissing(false);
    window.location.href = schemeUrl;

    setTimeout(() => {
      document.removeEventListener('visibilitychange', onAway);
      window.removeEventListener('pagehide', onAway);
      window.removeEventListener('blur', onAway);

      if (!switchedAway && !document.hidden) {
        setAppMissing(true);
      }
    }, 1800);
  };


  useEffect(() => {
    if(Platform.OS !== 'web'){
      hide();
    }
  }, []);

  return (
    <Animated.View
      style={{
        height: dimensions.height,
        backgroundColor: tw.color('secondary'),
        position: 'absolute',
        left:0, right: 0,
        // top: -200,
        top,
      }}
    >
      <SafeAreaView style={tw`flex-1`}>
          <View style={tw`absolute -top-67 h-100% left-0 right-0`}>
            <DDCircle fill="#410b61" />
          </View>

          <View style={tw`flex-2 items-center px-8 justify-around`}>
            <Illustration name="logo" width={160} height={96} />

            <View style={tw``}>
              <Text style={tw`text-white text-center text-3xl`}>¡Hola!</Text>
              <Text style={tw`text-white text-center text-xl`}>{invitation.resident?.name?.split(" ")?.[0]}</Text>
            </View>

            <Text style={tw`text-white text-base text-center mt-10`}>La administración de <Text>{invitation.community?.name}</Text> te invita a completar tu registro y activar tu cuenta.</Text>
          </View>

          {
            Platform.OS === 'web' ? (
              <View style={tw`bg-[#2e0845] py-14 flex-1 items-center px-6`}>
                {!appMissing ? (
                  <>
                    {/* Paso 1: abrir la app si ya está instalada */}
                    <TouchableOpacity style={tw`bg-primary py-5 items-center rounded-full w-90%`} onPress={tryOpenApp}>
                      <Text style={tw`text-white text-lg`}>Ya tengo la app · Abrir</Text>
                    </TouchableOpacity>

                    {/* Paso 2: descargar (siempre visible) */}
                    <Text style={tw`text-white/80 text-center mt-8 mb-3`}>¿Aún no tienes la app? Descárgala:</Text>
                    <StoreBadges />
                  </>
                ) : (
                  <>
                    {/* El intento de abrir falló => no está instalada */}
                    <Text style={tw`text-white text-lg text-center font-600`}>Aún no tienes la app</Text>
                    <Text style={tw`text-white/80 text-center mt-3 mb-6`}>
                      Descárgala aquí y, al abrirla, vuelve a tocar el enlace de tu invitación para completar tu registro.
                    </Text>
                    <StoreBadges />

                    <TouchableOpacity style={tw`mt-8`} onPress={tryOpenApp}>
                      <Text style={tw`text-white/70 text-center underline`}>Ya la instalé, abrir app</Text>
                    </TouchableOpacity>
                  </>
                )}
              </View>
            ) : (
              <View style = {tw`bg-[#2e0845] py-14 items-center`}>
                <TouchableOpacity style={tw`bg-primary py-5 items-center rounded-full w-90%`} onPress={hide}>
                  <Text style={tw`text-white text-lg`}>Completa tu registro</Text>
                </TouchableOpacity>
              </View>
            )
          }
      </SafeAreaView>
    </Animated.View>
  )
}


function InvitationPartial({ invitation, onSignup, insets }){
  return (
    <KeyboardAvoidingView 
      style={tw`flex-1`} behavior={Platform.OS === "ios" ? "padding" : "position"}>
      {/* <View style={tw``}> */}
      {/* Header */}
      <View style={tw`items-center bg-secondary rounded-b-2xl pt-[${insets.top + 30}] mb-5 px-5 overflow-hidden`}>
        <View style={tw`absolute -top-50 -bottom-20 left-0 right-0`}>
          <DDCircle fill="#410b61" />
        </View>

        <Illustration name="logo" width={160} height={72} style={tw`mb-6`} />


        <Text style={tw`text-white text-2xl font-600 text-center`}>Bienvenido</Text>
        <Text style={tw`text-white mb-8 text-base text-center`}>Termina tu registro para comenzar a usar DingDong</Text>


        <View style={tw`row mb-6`}>
          <Image source={invitation.community.image_path} style={tw`w-12 h-12 rounded-full`} />

          <View style={tw`ml-4`}>
            <Text style={tw`text-white text-lg font-600`}>{invitation.community?.name}</Text>
            <Text style={tw`text-white text-lg -mt-1`}>{invitation.resident?.unit?.name}</Text>
          </View>
        </View>
      </View>


      {/* Formulario */}
      <View style={tw`py-4 px-4`}>

        <SignUpForm
          invitation={invitation}
          onSignup={onSignup}
        />
      </View>
    </KeyboardAvoidingView>
  )
}


function AcceptInvitationPartial({ invitation, onAccepted, insets, navigateToRoot }){
  const dispatch = useDispatch()
  const { user, communities } = useSelector(state => state.status)
  const [isLoading, setIsLoading] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const isSecondHome = communities?.length >= 1;

  const handleAccept = () => {
    setIsLoading(true)
    setErrorMessage(undefined)

    api.post(`auth/invitation/accept`, { invitation_id: invitation.uuid })
      .then(({ data }) => {
        (dispatch as any)(updateStatus())
        setIsLoading(false)
        setIsAccepted(true)
      })
      .catch(({ response }) => {
        setIsLoading(false)
        if (response?.data?.message) {
          setErrorMessage(response.data.message)
        } else {
          setErrorMessage('Error al aceptar la invitación')
        }
      })
  }

  const handleContinue = () => {
    onAccepted?.()
  }

  return (
    <View style={tw``}>
      <View style={tw`items-center bg-secondary rounded-b-2xl pt-[${insets.top + 30}] mb-5 px-5 overflow-hidden`}>
        <View style={tw`absolute -top-50 -bottom-20 left-0 right-0`}>
          <DDCircle fill="#410b61" />
        </View>

        <Illustration name="logo" width={160} height={72} style={tw`mb-6`} />

        {!isAccepted && (
          <>
            {/* Dejamos el nombre que viene en la invitación */}
            <Text style={tw`text-white text-2xl font-600 text-center`}>Hola {invitation.resident.name?.split(" ")[0]}</Text>
            <Text style={tw`text-white mb-4 text-base text-center`}>Te han invitado a unirte a:</Text>

            <View style={tw`row mb-6`}>
              {
                invitation.community.image_path && 
                  <Image source={invitation.community.image_path} style={tw`w-12 h-12 rounded-full mr-6`} />
              }

              <View style={tw`mt-4`}>
                <Text style={tw`text-white text-center text-lg font-600`}>{invitation.community?.name}</Text>
                <Text style={tw`text-white text-center text-lg -mt-1`}>{invitation.resident?.unit?.name}</Text>
              </View>
            </View>
          </>
        )}

        {isAccepted && (
          <>
            <Text style={tw`text-white text-2xl font-600 text-center`}>Invitacion aceptada</Text>
            <Text style={tw`text-white mb-8 text-base text-center`}>Ya puedes acceder a tu nueva vivienda</Text>
          </>
        )}
      </View>

      <View style={tw`py-20 px-4`}>
        {errorMessage && (
          <Text style={tw`text-red-400 text-center my-4 text-base`}>{errorMessage}</Text>
        )}

        {!isAccepted && (
          <View style={tw`gap-y-4`}>
            <TouchableOpacity
              style={tw.style(`bg-primary py-4 items-center self-center rounded-full w-90%`, isLoading && 'opacity-50')}
              onPress={handleAccept}
              disabled={isLoading}
            >
              <Text style={tw`text-white text-lg font-600`}>
                {isLoading ? 'Aceptando...' : 'Aceptar invitacion'}
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={tw`py-4 items-center self-center w-90%`}
              onPress={navigateToRoot}
            >
              <Text style={tw`text-gray-500 text-base`}>Cancelar</Text>
            </TouchableOpacity>
          </View>
        )}

        {isAccepted && (
          <View style={tw`gap-y-4`}>
            {isSecondHome && (
              <View style={tw`bg-gray-100 rounded-xl px-5 py-4 mb-4`}>
                <Image source={require('./multivivienda-instrucciones.png')} style={tw`h-[250px] w-full mb-6`} contentFit='contain' />
              </View>
            )}

            <TouchableOpacity
              style={tw`bg-primary py-4 items-center self-center rounded-full w-90%`}
              onPress={handleContinue}
            >
              <Text style={tw`text-white text-lg font-600`}>Continuar</Text>
            </TouchableOpacity>
          </View>
        )}
      </View>
    </View>
  )
}


function LoginOrRegisterPartial({ invitation, onLoginPressed, onRegisterPressed, insets }){
  return (
    <View style={tw``}>
      <View style={tw`items-center bg-secondary rounded-b-2xl pt-[${insets.top + 30}] mb-5 px-5 overflow-hidden`}>
        <View style={tw`absolute -top-50 -bottom-20 left-0 right-0`}>
          <DDCircle fill="#410b61" />
        </View>

        <Illustration name="logo" width={160} height={72} style={tw`mb-6`} />

        <Text style={tw`text-white text-2xl font-600 text-center`}>Bienvenido</Text>
        <Text style={tw`text-white mb-4 text-base text-center`}>Te han invitado a unirte a:</Text>

        <View style={tw`row mb-6`}>
          <Image source={invitation.community.image_path} style={tw`w-12 h-12 rounded-full`} />

          <View style={tw`ml-4`}>
            <Text style={tw`text-white text-lg font-600`}>{invitation.community?.name}</Text>
            <Text style={tw`text-white text-lg -mt-1`}>{invitation.resident?.unit?.name}</Text>
          </View>
        </View>
      </View>

      <View style={tw`py-10 px-4`}>
        <Text style={tw`text-gray-600 text-center text-base mb-8`}>
          Para continuar, inicia sesion si ya tienes cuenta o registrate si eres nuevo.
        </Text>

        <View style={tw`gap-y-4`}>
          <TouchableOpacity
            style={tw`bg-primary py-4 items-center self-center rounded-full w-90%`}
            onPress={onLoginPressed}
          >
            <Text style={tw`text-white text-lg font-600`}>Ya tengo cuenta</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={tw`bg-secondary py-4 items-center self-center rounded-full w-90%`}
            onPress={onRegisterPressed}
          >
            <Text style={tw`text-white text-lg font-600`}>Soy nuevo, registrarme</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  )
}


function MagicLinkPartial({ invitation, onOk, insets, navigateToRoot }){
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [isLogged, setIsLogged] = useState(false);

  const doMagicLinkRegister = () => {
    const data = {
      invitation_id: invitation.uuid,
    }

    setIsLoading(true)
    setErrorMessage()


    api.post(`auth/magic-link/register`, data)
      .then(({ data }) => {
        dispatch(actions.login(data.user, data.access_token))
        setIsLogged(true)
        setIsLoading(false)
      })
      .catch(({ response }) => {
        setIsLoading(false)

        if (response.data?.message) {
          setErrorMessage(response.data?.message)
        }
      })
  }

  useEffect(() => {
    doMagicLinkRegister()
  }, []);

  return (
    <View style={tw``}>
      {/* Header */}
      <View style={tw`items-center bg-secondary rounded-b-2xl pt-[${insets.top + 30}] mb-5 px-5 overflow-hidden`}>
        <View style={tw`absolute -top-50 -bottom-20 left-0 right-0`}>
          <DDCircle fill="#410b61" />
        </View>

        <Illustration name="logo" width={160} height={72} style={tw`mb-6`} />


        {isLogged && (
          <>
            <Text style={tw`text-white text-2xl font-600 text-center`}>¡Ya estás dentro!</Text>
            <Text style={tw`text-white mb-8 text-base text-center`}>Ya puedes continuar usando tu cuenta DingDong</Text>
          </>
        )}
      </View> 

      <View style={tw`py-40 px-4`}>
        {
          errorMessage &&
            <Text style={tw`text-red-400 text-center my-10 text-xl`}>{errorMessage}</Text>
        }

        {
          (isLoading) &&
            <>
              <Text style={tw`text-gray-400 text-2xl font-600 text-center mb-10`}>Cargando...</Text>
            </>
        }

        {
          isLogged && (
            <TouchableOpacity
              style={tw.style(`bg-primary py-4 items-center self-center rounded-full w-90%`, !isLogged && 'bg-primary/30')}
              onPress={onOk}
            >
              <Text style={tw`text-white text-lg font-600`}>Continuar</Text>
            </TouchableOpacity>
          )
        }

        {
          (errorMessage && ! isLogged) && (
            <TouchableOpacity
              style={tw.style(`bg-primary py-4 items-center self-center rounded-full w-90%`)}
              onPress={navigateToRoot}
            >
              <Text style={tw`text-white text-lg font-600`}>Regresar</Text>
            </TouchableOpacity>
          )
        }
      </View>
    </View>
  )
}


export default function InvitationScreen({ route, navigation }) {
  const [invitation, setInvitation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [invalidInvitation, setInvalidInvitation] = useState(false);
  const [networkError, setNetworkError] = useState(false);
  const [showWelcomeWizard, setShowWelcomeWizard] = useState(false);
  const [showRegistrationForm, setShowRegistrationForm] = useState(false);


  const token = route.params?.invitationId;
  const showQR = route.params?.qr;

  const { isLogged } = useSelector(state => state.auth)


  useEffect(() => {
    loadInvitation()
  }, [token]);


  useEffect(() => {
    if(invitation){
      if(invitation.type === 'magic_link'){
        // Si es magic link, navegar directo
        // navigation.setOptions({ headerShown: false });
      }
    }
  }, [invitation]);

  /////

  const loadInvitation = () => {
    setIsLoading(true)
    setInvalidInvitation(false)
    setNetworkError(false)
    setInvitation(null)

    api.get(`/auth/invitation/${token}`)
      .then(({ data }) => {
        setIsLoading(false)
        setInvitation(data)

        // Valida si hay un usuario logueado y la invitacion es para ese usuario
        // if (user?.id && user.id !== data.user_id) {
        //   setInvalidInvitation(true)
        // } else {
        //   setInvitation(data)
        // }
      })
      .catch(error => {
        setIsLoading(false)
        console.log("api error", error)
        if (error.response) {
          setInvalidInvitation(true)
        } else {
          setNetworkError(true)
        }
        // navigateToRoot()
      })
  }



  function navigateToRoot() {
    if(isLogged){
      navigation.navigate("Main.Stack");
    }else{
      navigateToLogin();
    }
  }

  function navigateToLogin(){
    navigation.reset({
      index: 0,
      routes: [
        {
          name: 'Auth.Login',
        },
      ],
    });
  }

  const insets = useSafeAreaInsets()

  

  return (
    <>
      <KeyboardAvoidingView
        style={tw`flex-1`}
        behavior={(Platform.OS === 'ios') ? "padding" : undefined}
      >
        <ScrollView
          contentContainerStyle={tw`pb-[${insets.bottom}]`}
        >
          {
            (isLoading) &&
              <View>
                <Text style={tw`py-40 text-center text-gray-400 text-xl`}>Cargando...</Text>
              </View>
          }
          {
            (invalidInvitation) &&
            <View style={tw`py-40 `}>
                <Text style={tw`text-center mb-12 text-gray-400 text-xl`}>Invitación inválida</Text>

                <TouchableOpacity
                  style={tw`bg-primary py-4 items-center self-center rounded-full w-90%`}
                  onPress={navigateToRoot}
                >
                  <Text style={tw`text-white text-lg font-600`}>Regresar</Text>
                </TouchableOpacity>
              </View>
          }
          {
            (networkError) &&
            <View style={tw`py-40 `}>
                <Text style={tw`text-center mb-12 text-gray-400 text-xl`}>Error al cargar</Text>

                <TouchableOpacity
                  style={tw`bg-primary py-4 items-center self-center rounded-full w-90%`}
                  onPress={loadInvitation}
                >
                  <Text style={tw`text-white text-lg font-600`}>Intentar de nuevo</Text>
                </TouchableOpacity>
              </View>
          }



          {
            invitation?.type == "invitation" && isLogged &&
              <AcceptInvitationPartial
                invitation={invitation}
                onAccepted={() => {
                  navigateToRoot()
                }}
                navigateToRoot={navigateToRoot}
                insets={insets}
              />
          }

          {
            invitation?.type == "invitation" && !isLogged && !showRegistrationForm &&
              <LoginOrRegisterPartial
                invitation={invitation}
                onLoginPressed={() => {
                  navigation.navigate('Auth.Login', { returnTo: 'invitation', invitationId: token })
                }}
                onRegisterPressed={() => {
                  setShowRegistrationForm(true)
                }}
                insets={insets}
              />
          }

          {
            invitation?.type == "invitation" && !isLogged && showRegistrationForm &&
              <InvitationPartial
                invitation={invitation}
                onSignup={() => {
                  setShowWelcomeWizard(true)
                }}
                insets={insets}
              />
          }

          {
            invitation?.type == "magic_link" &&
              <MagicLinkPartial
                invitation={invitation}
                navigateToRoot={navigateToRoot}
                onOk={navigateToRoot}
                insets={insets}
              />
          }
        </ScrollView>
      </KeyboardAvoidingView>


      {
        invitation &&
          <WelcomeScreen invitation={invitation} />
      }

      {
        showWelcomeWizard &&
          <WelcomeWizard 
            onDone={() => {
              setTimeout(() => {
                navigateToRoot()
              }, 500)
            }}
          />
      }
    </>
  )
}

